import React from 'react';

import { SidebarFilterSlidersIcon } from '@vk-hr-tek/ui/icons/SidebarIcons/SidebarFilterSlidersIcon';

import { UserSectionItem } from '@app/gen/side_menu';

import { SidebarMenu } from '../SidebarMenu';

import { SidebarItem } from './SidebarItem';

interface SidebarUserSectionItemProps {
  item: UserSectionItem;
  sidebarOpened: boolean;
  isSkeletonLoading: boolean;
  onMenuItemClick: (pageTitle: string) => void;
  isActive: (path: string, href: string) => boolean;
  pathname: string;
}

export const SidebarUserSectionItem = ({
  item,
  sidebarOpened,
  isSkeletonLoading,
  onMenuItemClick,
  isActive,
  pathname,
}: SidebarUserSectionItemProps) => {
  const { name, children } = item;
  const settingsLink = '/user_section';
  const isActiveItem = isActive(pathname, settingsLink);

  return (
    <>
      <SidebarMenu
        menuLabel={name}
        sidebarOpened={sidebarOpened}
        skeletonLoading={isSkeletonLoading}
        key={item.name}
        onMenuItemClick={onMenuItemClick}
        items={children}
      />
      <SidebarItem
        href={settingsLink}
        color="original.brand.primary"
        icon={<SidebarFilterSlidersIcon />}
        aqaClass={`aqa_${name}`}
        title="Настроить блок"
        sidebarOpened={sidebarOpened}
        isActive={isActiveItem}
        skeletonLoading={isSkeletonLoading}
        onClick={onMenuItemClick}
        isCustom={false}
      />
    </>
  );
};
